import {
	CrossStoreReconciliationExportType,
	CrossStoreReconciliationViewMode,
	EGroupInclusionType,
	IExportFilter,
	IGroupInclusion,
	IPositionsExported,
} from "@DataPages/types/salesOperations/salesPerformance/crossStoreReconciliationUtils";

export const tableFiltersInitialState: TableFilterState = {
	groupsInclusions: [
		{
			label: EGroupInclusionType.RECOMMENDED_FOR_RECONCILIATION,
			value: EGroupInclusionType.RECOMMENDED_FOR_RECONCILIATION,
		},
	],
	exportFilters: [] as IExportFilter[],
	positionsExported: [] as IPositionsExported[],
};

export type TableFilterAction =
	| { type: "SET_GROUP_INCLUSIONS"; payload: IGroupInclusion[] }
	| { type: "SET_EXPORT_FILTER"; payload: IExportFilter[] }
	| { type: "SET_POSITIONS_EXPORTED"; payload: IPositionsExported[] };

// Define your state type
export type TableFilterState = {
	groupsInclusions: IGroupInclusion[];
	exportFilters: IExportFilter[];
	positionsExported: IPositionsExported[];
};

function tableFilterReducer(state: TableFilterState, action: TableFilterAction): TableFilterState {
	switch (action.type) {
		case "SET_GROUP_INCLUSIONS":
			return {
				...state,
				exportFilters: [] as IExportFilter[],
				groupsInclusions: action.payload,
			};
		case "SET_EXPORT_FILTER":
			return {
				...state,
				groupsInclusions: [],
				exportFilters: action.payload,
			};
		case "SET_POSITIONS_EXPORTED":
			return {
				...state,
				positionsExported: action.payload,
			};
		default:
			return state;
	}
}

export type ReconciliationExportOptions = {
	viewMode: CrossStoreReconciliationViewMode;
	exportMode: CrossStoreReconciliationExportType;
	controlType?: string;
	branchId?: string;
	markAsReconciled: boolean;
};
export type ReconciliationExportAction =
	| { type: "setViewMode"; value: CrossStoreReconciliationViewMode }
	| { type: "setExportMode"; value: CrossStoreReconciliationExportType }
	| { type: "setControlType"; value?: string }
	| { type: "setBranchId"; value?: string }
	| { type: "setMarkAsReconciled"; value: boolean }
	| { type: "reset"; value?: Partial<ReconciliationExportOptions> };
export const initialReconciliationOptions: ReconciliationExportOptions = {
	viewMode: "ITEMIZED",
	exportMode: "CSV",
	controlType: undefined,
	branchId: undefined,
	markAsReconciled: false,
};

function reconciliationExportReducer(state: ReconciliationExportOptions, action: ReconciliationExportAction): ReconciliationExportOptions {
	switch (action.type) {
		case "setViewMode":
			return { ...state, viewMode: action.value };
		case "setExportMode":
			const shouldMarkAsReconciled = action.value === "GENERAL_JOURNAL";
			return { ...state, markAsReconciled: shouldMarkAsReconciled, exportMode: action.value };
		case "setControlType":
			// common dependency: changing controlType invalidates branch selection
			return { ...state, controlType: action.value };
		case "setBranchId":
			return { ...state, branchId: action.value };
		case "setMarkAsReconciled":
			return { ...state, markAsReconciled: action.value };
		case "reset":
			return { ...initialReconciliationOptions, ...action.value };
		default:
			return state;
	}
}

export { reconciliationExportReducer, tableFilterReducer };
